import { toggleSlide } from "marketingWebsite/utils/toggleSlide.js"

// Switch prices in table between monthly and yearly plan
export default function usePlanSwitcher () {
    function handleSwitchPlan ( event ) {
        event.preventDefault()

        const switcher = event.target
        const isMonthlyActive = switcher.classList.contains( "active" )
        switcher.classList.toggle( "active", !isMonthlyActive )

        document
            .querySelectorAll( ".service-developer-plan__monthly, .service-developer-plan__yearly" )
            .forEach(
                // We can't simply shorten it to just toggleSlide,
                // because it overrides the default delay (second parameter) with the wrong value.
                // We need to pass proper arguments
                ( el ) => toggleSlide( el )
            )
    }

    function init () {
        const switcher = document.querySelector( ".services-developer-plan__actions a" )

        // For propper toggling add initial height
        document
            .querySelectorAll( ".service-developer-plan__yearly" )
            .forEach( ( planEl ) => {
                const height = planEl.clientHeight
                planEl.style.height = `${ height }px`
                planEl.style.display = "block"
            })

        switcher.addEventListener( "click", handleSwitchPlan )
    }

    init()
}
